import { render, staticRenderFns } from "./NovaSideNavbar.vue?vue&type=template&id=58c4695a&lang=pug&"
import script from "./NovaSideNavbar.vue?vue&type=script&lang=js&"
export * from "./NovaSideNavbar.vue?vue&type=script&lang=js&"
import style0 from "./NovaSideNavbar.vue?vue&type=style&index=0&id=58c4695a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports